export type View = 'login' | 'identification' | 'new-password'

export interface LoginInput {
    ibInstitutionCode: string
    userID: string
    password: string
}

export interface ResetInput {
    ibInstitutionCode: string
    email: string
    otp: string
    newPassword: string
    confirmPassword: string
}

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const isValidCode = (value: string) => value.trim().length > 0 && value.trim().length !== 7